import { app } from '../../../../app';

class Service {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    query(applicationId, accountId) {
        return this.$http
            .get(`app/rest/loginroles/${applicationId}/account/${accountId}`)
            .then((response) => response.data);
    }
}

app.service('LoginRolesService', Service);



// WEBPACK FOOTER //
// ./src/portal/states/user/applications/login-role-select/login-roles.service.js